import { useContext, useEffect, useMemo, useState } from "react";
import UserContext from "../../contexts/UserContext";
import { AppModel } from "../../models/app";
import { IUserPreference } from "../../models/user";
import { useGetCatalogueAppsQuery } from "../../services/apis";
import { IApp, APP_NAMES } from "../../types/app";
import {
  PEOPLE_FINDER_ID,
  RAAS_INTERNAL_PORTAL_ID,
} from "../../constants/mockData/catalogueApps";
import { getAppName } from "../../utils/common";

export const useGetCatalogueApps = () => {
  const { data: catalogueApps, isLoading } =
    useGetCatalogueAppsQuery();
  const userModel = useContext(UserContext);

  const [apps, setApps] = useState<AppModel[]>([]);

  useEffect(() => {
    if (catalogueApps) {
      const userPrefs: IUserPreference | undefined =
        userModel.getUserPreference();
      const userPermissions: string[] = userModel.getUser().roles;
      const canAccessRaasInternalPortal =
        userModel.canAccessRaasInternalPortal();
      const apps = catalogueApps
        .map((app: IApp) => {
          const newApp: AppModel = new AppModel(app);
          newApp.setBookmarked(
            userPrefs?.apps?.includes(app.id) ||
            app.id === PEOPLE_FINDER_ID ||
            (app.id === "company_builder" && getAppName() === APP_NAMES.ESP) ||
            false
          );
          return newApp;
        })
        .filter((app: AppModel) => {
          const appObj: IApp = app.getValue();
          if (appObj.id === RAAS_INTERNAL_PORTAL_ID) {
            return canAccessRaasInternalPortal;
          }

          if (
            (appObj.isFindemApp &&
              userPermissions.includes(appObj.permission as string)) ||
            !appObj.isFindemApp
          ) {
            return true;
          }
          return false;
        });
      setApps(apps);
    }
  }, [catalogueApps, userModel]);

  return { isLoading, apps };
};

export const useGetBookmarkedApps = (catalogueApps: AppModel[]) => {
  const bookMarkedApps: AppModel[] = useMemo(() => {
    return catalogueApps.filter((app: AppModel) => app.getValue().bookmarked);
  }, [catalogueApps]);

  return bookMarkedApps;
};
